import styled from "@emotion/styled";
import { Grid, Tooltip } from "@mui/material";
import React from "react";
import { COLOR_MAP } from "../../constants/ColorNames";

type TooltipPropsType = {
  title: string;
  children: React.ReactElement<any, any>;
  offset?: [number, number];
  width?: string;
  customZIndex?: number
  arrowShift?:string
};

const ToolTipContainer = styled(Grid)`
  padding: 1.2rem;
  color: ${COLOR_MAP.WHITE};
  background-color: ${COLOR_MAP.LIGHT_GREY};
  border-radius: 0.4rem;
  font-family: NOTO SANS;
`;

const TooltipText = styled.p`
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 2.2rem;
  margin: 0;
`;

export const TooltipContent = ({ title }: { title: string }) => {
  return (
    <ToolTipContainer container spacing={"1.2rem"}>
      <TooltipText>{title}</TooltipText>
    </ToolTipContainer>
  );
};

const CommonTooltip = (props: TooltipPropsType) => {
  const { title, children, offset, width, customZIndex = 'inherit',arrowShift='' } = props;
  if (!title) return children
  return (
    <Tooltip
      title={<TooltipContent title={title} />}
      arrow
      placement="top"
      PopperProps={{
        modifiers: offset
          ? [
              {
                name: "offset",
                options: {
                  offset: offset,
                },
              },
            ]
          : undefined,
      }}
      componentsProps={{
        popper: {
          sx: {
            ...(!!width && { width }),
            zIndex: customZIndex,
          },
        },
        tooltip: {
          sx: {
            zIndex: customZIndex,
            "& .MuiGrid-root":{
              padding:'4px 8px'
            }
          },
        },
        arrow: {
          sx: {
            ...(arrowShift !== '' && { marginLeft: `${arrowShift}` }),
          },
        },
      }}
      

    >
      {children}
    </Tooltip>
  );
};

export default CommonTooltip;
